import { ReactNode } from 'react';
import { Box, Modal, Typography } from '@mui/material';

import { Button } from '~/components/ui/button';
import { COLORS } from '~/styles/colors';

type ConfirmPopupProps = {
  icon: ReactNode;
  title: string;
  subTitle?: string;
  textBtn1: string;
  textBtn2: string;
  onClose: () => void;
  onAccept: () => void;
  open: boolean;
  btnColor2?: string;
};

export const ConfirmPopup = ({
  icon,
  title,
  subTitle,
  textBtn1,
  textBtn2,
  onClose,
  onAccept,
  open,
  btnColor2,
}: ConfirmPopupProps) => {
  return (
    <Modal onClose={onClose} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} open={open}>
      <Box sx={{ padding: 4, background: COLORS.white, outline: 'none', borderRadius: 2, maxWidth: 480 }}>
        <Box sx={{ textAlign: 'center' }}>{icon}</Box>
        <Typography sx={{ mt: 2, fontSize: 30, textAlign: 'center' }}>{title}</Typography>
        <Typography sx={{ mt: 2, color: COLORS.black06, mb: 2, textAlign: 'center' }}>{subTitle}</Typography>

        <Box sx={{ justifyContent: 'center', display: 'flex', mt: 4 }}>
          <Button
            onClick={onClose}
            variant="outlined"
            color={COLORS.primary}
            size="small"
            sx={{ mr: 3, width: '100%' }}
          >
            {textBtn1}
          </Button>
          <Button onClick={onAccept} size="small" sx={{ background: btnColor2, width: '100%' }} variant="contained">
            {textBtn2}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
